import React from 'react';
import RocketsLogic from '../components/rockets/RocketsLogic';

function Rockets() {
  return (
    <RocketsLogic />
  );
}

export default Rockets;
